import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { initGA, trackPageView } from './googleAnalytics';

export const useGoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    initGA();
  }, []);

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);
};
